import gql from 'graphql-tag';

export default gql`
    query GetVosUploadImages($input: GetVosUploadsInput) {
        getVosUploadImages(input: $input) {
            id
            week
            startDate
            endDate
            imageName
            uploadedBy
            uploadDate
            downloadLink
        }
    }
`;
